export const ROUTE_OVERVIEW = 'overview';
export const ROUTE_MACHINES = 'machines';
export const ROUTE_PRESETS = 'presets';
